module.exports = __webpack_public_path__ + "img/destination_uk.f2b75ae1.jpg";